// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

const CountryWhiteListSettingsController = function ($scope, gettext, gettextCatalog, CountryWhiteListSettings,
                                                     CountryList, AccountSettings) {
    $scope.companySettings = AccountSettings.get();
    $scope.locale = gettextCatalog.currentLanguage.toUpperCase();
    $scope.countries = [];
    $scope.CountryWhiteListSettings = {};
    
    loadCountries();
    loadWhiteListCountries();

    $scope.addCountryToWhiteList = function (newCountry) {
        if (!newCountry) {
            return;
        }
        let isCountryAlreadyAdded = $scope.CountryWhiteListSettings.CountryWhiteList.some(function (country) {
            return country.TwoLetterCode === newCountry;
        });
        if (isCountryAlreadyAdded) {
            return;
        }
        $scope.CountryWhiteListSettings.CountryWhiteList.push({
            Name: getCountryName(newCountry, $scope.locale),
            TwoLetterCode: newCountry
        });
        $scope.CountryWhiteListSettings.CountryWhiteList.sort(compareCountryByName);
    }

    $scope.removeCountryFromWhiteList = function (removingCountry) {
        $scope.CountryWhiteListSettings.CountryWhiteList =
            $scope.CountryWhiteListSettings.CountryWhiteList.filter(function (country) {
                return country !== removingCountry
            });
    }

    $scope.save = function () {
        let isCountryListNotEmptyAndFeatureEnabled = $scope.CountryWhiteListSettings.CountryWhiteList.length !== 0 &&
            $scope.CountryWhiteListSettings.IsEnabled;
        if (isCountryListNotEmptyAndFeatureEnabled || !$scope.CountryWhiteListSettings.IsEnabled) {
            CountryWhiteListSettings.save($scope.CountryWhiteListSettings).then($scope.notifySuccess());
        }
        else {
            $scope.notify("error", gettextCatalog.getString(gettext(("Saving with an empty list is not possible"))));
        }
    }

    $scope.addDefaultCountryIfListEmpty = function () {
        loadWhiteListCountries(setCountryWhiteListSettingsToActualState);
    }

    function loadCountries() {
        CountryList.getCountries().then(function (response) {
                $scope.countries = response.data.slice();
            },
            function () {
                $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
            });
    }

    function getCountryName(code, locale) {
        if ($scope.countries && code) {
            let country = $scope.countries.find(function (country) {
                return country.TwoLetterCode === code
            });
            return (locale in country) ? country[locale] : country["EN"];
        }
    }

    function compareCountryByName(firstCountry, secondCountry) {
        if (firstCountry.Name > secondCountry.Name) {
            return 1;
        }
        if (firstCountry.Name < secondCountry.Name) {
            return -1;
        }
        return 0;
    };
    
    function loadWhiteListCountries(callback){
        CountryWhiteListSettings.get($scope.locale).then(function (response) {
            $scope.CountryWhiteListSettings.CountryWhiteList = response.data.CountryWhiteList
            $scope.CountryWhiteListSettings.RestrictPaymentsByCustomerCountry = response.data.RestrictPaymentsByCustomerCountry;
            if(callback)
            {
                callback();
            }
            else
            {
                $scope.CountryWhiteListSettings.IsEnabled = response.data.IsEnabled;
            }
            
        }, function () {
            $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
        });
    }
    
    function setCountryWhiteListSettingsToActualState() {
        if ($scope.CountryWhiteListSettings.CountryWhiteList.length === 0 &&
            $scope.companySettings.InvoiceAddress.Country) {
            $scope.CountryWhiteListSettings.CountryWhiteList.push({
                Name: getCountryName($scope.companySettings.InvoiceAddress.Country, $scope.locale),
                TwoLetterCode: $scope.companySettings.InvoiceAddress.Country
            })
            $scope.CountryWhiteListSettings.IsEnabled = true;
        }
    }

}

CountryWhiteListSettingsController.$inject = ['$scope', 'gettext', 'gettextCatalog', 'CountryWhiteListSettings',
    'CountryList', 'AccountSettings'];
